module.exports = __webpack_public_path__ + "img/dock-barrier-no.a2e0e435.svg";